import { render, staticRenderFns } from "./TarificationsNews.vue?vue&type=template&id=1409a226&"
import script from "./TarificationsNews.vue?vue&type=script&lang=js&"
export * from "./TarificationsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports